module.exports = __webpack_public_path__ + "img/rate_empty.1c412fa7.png";